<template>
  <div class="profile-home">
    <div v-if="isMounted && currentEnrollmentLabel" class="profile-enrollment">
      <div
        :class="
          `profile-enrollment__desertion-rate profile-enrollment__desertion-rate--${desertionStatusColor}`
        "
      >
        <b>{{ studentProfile.student.desertionProbability | percentageSimple }}</b> riesgo de
        deserción
      </div>

      <div class="profile-enrollment__content">
        <p class="program">
          <b>
            Carrera:
          </b>
          {{ currentEnrollmentLabel || "" }}
        </p>

        <dropdown-button
          v-if="enrollmentOptions.length > 1"
          :options="enrollmentOptions"
          className="profile-enrollment__dropdown"
        >
          Cambiar carrera

          <template #icon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M14.0002 7.99995C14.3682 8.00012 14.6662 8.29886 14.6662 8.66694V9.99995C14.6662 10.884 14.3157 11.7323 13.6906 12.3574C13.0655 12.9825 12.2172 13.333 11.3332 13.333H3.60856L5.13786 14.8623C5.39805 15.1226 5.39815 15.5443 5.13786 15.8046C4.87756 16.0649 4.45584 16.0648 4.19548 15.8046L1.52849 13.1376C1.33187 12.9409 1.28334 12.6519 1.38395 12.4101C1.3889 12.3983 1.39594 12.3874 1.40153 12.3759C1.43313 12.3109 1.47449 12.2493 1.52849 12.1953L4.19548 9.52827C4.4558 9.26831 4.87761 9.2682 5.13786 9.52827C5.39821 9.78862 5.39821 10.2113 5.13786 10.4716L3.60954 11.9999H11.3332C11.8636 11.9999 12.3722 11.7891 12.7472 11.414C13.1223 11.0389 13.3332 10.5304 13.3332 9.99995V8.66694C13.3332 8.29875 13.632 7.99995 14.0002 7.99995ZM10.8615 0.195262C11.1218 -0.0650874 11.5445 -0.0650874 11.8049 0.195262L14.4718 2.86225C14.4877 2.87817 14.4999 2.89696 14.5138 2.91401C14.5273 2.93054 14.542 2.94603 14.5539 2.96382C14.6788 3.15065 14.6996 3.38593 14.6154 3.58882C14.6076 3.60761 14.5965 3.62465 14.5871 3.64253C14.5765 3.66258 14.5666 3.68299 14.5539 3.7021C14.542 3.7199 14.5273 3.73536 14.5138 3.7519C14.4998 3.76915 14.4879 3.78855 14.4718 3.80464L11.8049 6.47163C11.5445 6.7319 11.1218 6.73195 10.8615 6.47163C10.6013 6.2113 10.6013 5.7886 10.8615 5.52827L12.3898 3.99995H4.66618C4.13587 4.00004 3.62711 4.21089 3.25212 4.58589C2.87715 4.96094 2.66618 5.4696 2.66618 5.99995V7.33296C2.66618 7.70104 2.36821 7.99977 2.00017 7.99995C1.63198 7.99995 1.33317 7.70115 1.33317 7.33296V5.99995C1.33317 5.11589 1.68461 4.26765 2.30974 3.64253C2.93475 3.01768 3.78239 2.66703 4.66618 2.66694H12.3908L10.8615 1.13765C10.6016 0.877344 10.6015 0.455496 10.8615 0.195262Z"
                fill="#465669"
              />
            </svg>
          </template>
        </dropdown-button>
      </div>
    </div>

    <loading v-if="isLoading" />
    <div v-else class="home-grid">
      <div class="infographic">
        <ul class="infographic-tabs">
          <li :class="{ active: currentChart == 'grades' }">
            <a href="#" @click.prevent="currentChart = 'grades'">Promedio semestral</a>
          </li>
        </ul>
        <div class="chart">
          <grades-chart
            v-if="currentChart == 'grades'"
            :styles="chartStyles"
            :student-id="studentId"
            :enrollment-id="selectedEnrollmentId"
          ></grades-chart>
          <assistance-chart
            v-if="currentChart == 'assistance'"
            :styles="chartStyles"
          ></assistance-chart>
        </div>
      </div>

      <div class="main-box">
        <div class="title">
          <a class="title-link" href="#" @click.prevent="navigateTo('app.profile.alerts')">
            <span>Alertas ({{ studentProfile.activeAlerts }})</span>
            <next-arrow-icon></next-arrow-icon>
          </a>
        </div>
        <div class="body is-hidden-mobile">
          <h4 class="is-marginless has-text-weight-medium body__title">FACTORES DE RIESGO</h4>
          <div class="risk-factors">
            <div v-for="r in riskFactors" v-bind:key="r.code" class="risk-factors-item">
              <span class="risk-factor-indicator" :class="{ 'is-at-risk': r.on }"></span>
              <span class="risk-factor-name fs-14 is-lowercase">{{ r.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="main-box">
        <a class="title-link" href="#" @click.prevent="navigateTo('app.profile.attentions')">
          <span>Atenciones ({{ studentProfile.attentionStats.total }})</span>
          <next-arrow-icon></next-arrow-icon>
        </a>
        <div class="body is-hidden-mobile center-content">
          <div class="metric-list">
            <div class="metric-list-item">
              <span class="metric-value">{{ studentProfile.attentionStats.pending }}</span>
              <span class="metric-concept">Pendientes</span>
            </div>
            <div class="metric-list-item">
              <span class="metric-value">{{ studentProfile.attentionStats.done }}</span>
              <span class="metric-concept">Realizadas</span>
            </div>
            <div class="metric-list-item">
              <span class="metric-value">
                {{ studentProfile.attentionStats.participation | percentage }}
              </span>
              <span class="metric-concept">Participación</span>
            </div>
          </div>
        </div>
      </div>

      <div class="main-box">
        <a class="title-link" href="#" @click.prevent="navigateTo('app.profile.grades')">
          <span>Notas</span>
          <next-arrow-icon></next-arrow-icon>
        </a>
        <div class="body is-hidden-mobile center-content">
          <div class="metric-list">
            <div class="metric-list-item">
              <span class="metric-value">{{ studentProfile.student.currentLevel }}</span>
              <span class="metric-concept">Nivel</span>
            </div>
            <div class="metric-list-item">
              <span class="metric-value">
                {{
                  studentProfile.student.currentCurricularProgress | percentage(this.institution)
                }}
              </span>
              <span class="metric-concept">Créditos</span>
            </div>
            <div class="metric-list-item">
              <span class="metric-value">{{ average | humanizeFloat }}</span>
              <span class="metric-concept">Promedio</span>
            </div>
          </div>
        </div>
      </div>
      <div class="main-box">
        <a class="title-link" href="#" @click.prevent="navigateTo('app.profile.comments')">
          <span>Comentarios ({{ studentProfile.totalComments }})</span>
          <next-arrow-icon></next-arrow-icon>
        </a>
        <div v-if="studentProfile.totalComments !== 0" class="body is-hidden-mobile">
          <div class="comments-list">
            <div v-for="c in studentProfile.latestComments" :key="c.id" class="comment-item">
              <div class="comment-meta has-text-weight-semibold">
                {{ c.author.name }}, {{ c.createdAt | humanizeDate }}
              </div>
              <p class="comment-text">{{ c.comment | truncate(MAX_LENGTH_COMMENTS_RESUME) }}</p>
              <a
                v-if="c.comment.length > MAX_LENGTH_COMMENTS_RESUME"
                class="see-more"
                href="#"
                @click.prevent="navigateTo('app.profile.comments')"
                >ver más</a
              >
            </div>
          </div>
        </div>
        <p v-else class="body is-hidden-mobile center-content">No hay comentarios registrados.</p>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag"
import moment from "moment"
import PROFILE_DETAIL from "./graphql/Profile.gql"
import STUDENT_ENROLLMENTS from "./graphql/StudentEnrollments.gql"
import NextArrowIcon from "@/components/_base/NextArrowIconNeutral.vue"
import GradesChart from "./GradesChart.vue"
import AssistanceChart from "./AssistanceChart.vue"
import DropdownButton from "@/components/_base/DropdownButton.vue"
import Loading from "../../../shared/loading/loading.vue"

export default {
  name: "ProfileHome",
  props: {
    studentId: {
      type: String
    },
    user: {
      type: Object
    }
  },
  data() {
    return {
      MAX_LENGTH_COMMENTS_RESUME: 90,
      isLoading: true,
      enrollmentsLoaded: false,
      isMounted: false,
      studentProfile: {
        student: {
          currentRiskFactors: [],
          currentLevel: null,
          currentCurricularProgress: 0.0,
          desertionProbability: 0
        },
        activeAlerts: null,
        attentionStats: {
          done: 0,
          total: 0,
          participation: 0
        },
        latestComments: [],
        averageGrade: {
          grade: null
        }
      },
      currentChart: "grades",
      institution: this.user.institution_code,
      selectedEnrollmentId: null,
      studentEnrollments: {
        student: {
          enrollments: []
        }
      }
    }
  },
  mounted() {
    const currentEnrollment = window.localStorage.getItem("currentEnrollment")

    if (currentEnrollment) {
      const { enrollmentId, studentId } = JSON.parse(currentEnrollment)

      if (studentId === this.studentId) {
        this.setSelectedEnrollmentId(enrollmentId)
      } else {
        this.selectedEnrollmentId = null
        window.localStorage.removeItem("currentEnrollment")
      }
    }

    this.isMounted = true
  },
  apollo: {
    studentProfile: {
      query: PROFILE_DETAIL,
      fetchPolicy: "network-only",
      variables() {
        return {
          studentId: this.studentId,
          enrollmentId: this.selectedEnrollmentId || undefined
        }
      },
      skip() {
        return !this.enrollmentsLoaded
      },
      result() {
        this.isLoading = false
      }
    },
    studentEnrollments: {
      query: STUDENT_ENROLLMENTS,
      variables() {
        return { studentId: this.studentId }
      },
      skip() {
        return !this.isMounted
      },
      update(data) {
        const filteredEnrollments = data.studentProfile.student.enrollments.filter(
          enrollment => enrollment.term.actual
        )

        return {
          student: {
            ...data.studentProfile.student,
            enrollments: filteredEnrollments
          }
        }
      },
      result() {
        const hasSelectedEnrollment =
          this.selectedEnrollmentId &&
          (this.studentEnrollments.student.enrollments || []).find(
            enrollment => enrollment.id === this.selectedEnrollmentId
          )

        if (!hasSelectedEnrollment && this.studentEnrollments.student.enrollments.length) {
          this.setSelectedEnrollmentId(this.studentEnrollments.student.enrollments[0].id)
        }

        !this.enrollmentsLoaded && (this.enrollmentsLoaded = true)
      }
    }
  },
  computed: {
    chartStyles() {
      return {
        position: "relative",
        // width: "400px",
        height: "145px",
        overflow: "hidden"
      }
    },

    average() {
      return this.studentProfile.averageGrade.grade || 0.0
    },

    riskFactors() {
      const ret = [
        {
          code: "ACADEMIC",
          name: "Académico",
          on: false
        },
        {
          code: "VOCATIONAL",
          name: "Vocacional",
          on: false
        },
        {
          code: "ECONOMIC",
          name: "Económico",
          on: false
        },
        {
          code: "INSTITUTIONAL",
          name: "Institucional",
          on: false
        },
        {
          code: "PERSONAL",
          name: "Personal",
          on: false
        },
        {
          code: "OTHER",
          name: "Otros",
          on: false
        }
      ]

      // add a custom risk factor only for UAM
      if (this.institution === "uam.co") {
        ret.push({
          code: "VBG",
          name: "VBG",
          on: false
        })
      }

      // Activate the current factors
      ret.forEach(item => {
        item.on = this.studentProfile.student.currentRiskFactors.includes(item.code)
      })

      return ret
    },

    desertionStatusColor() {
      const desertionProbability = this.studentProfile.student.desertionProbability || 0

      if (
        desertionProbability == null ||
        Number.isNaN(desertionProbability) ||
        desertionProbability < 29
      ) {
        return "success"
      }

      if (desertionProbability >= 30 && desertionProbability < 70) {
        return "warning"
      }

      return "danger"
    },

    selectedEnrollmentDetails() {
      const enrollments = this.studentEnrollments.student.enrollments || []

      if (this.selectedEnrollmentId) {
        return enrollments.find(enrollment => enrollment.id === this.selectedEnrollmentId)
      }

      return enrollments.find(enrollment => enrollment.term.actual) || enrollments[0]
    },

    currentEnrollmentLabel() {
      const enrollment = this.selectedEnrollmentDetails

      if (!enrollment) {
        return ""
      }

      return `${enrollment.program.name} (${enrollment.estado.nombre} desde ${enrollment.term.name})`
    },

    enrollmentOptions() {
      const enrollments = this.studentEnrollments.student.enrollments || []

      // solo mostrar las que tengan estado actual
      return enrollments.map(enrollment => ({
        label: `${enrollment.program.name} (${enrollment.estado.nombre} desde ${enrollment.term.name})`,
        value: enrollment.id,
        isSelected: this.selectedEnrollmentId === enrollment.id,
        onClick: () => this.setSelectedEnrollmentId(enrollment.id)
      }))
    }
  },
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },
    setSelectedEnrollmentId(enrollmentId) {
      if (this.selectedEnrollmentId !== enrollmentId) {
        this.selectedEnrollmentId = enrollmentId

        window.localStorage.setItem(
          "currentEnrollment",
          JSON.stringify({
            enrollmentId,
            studentId: this.studentId
          })
        )

        if (!this.isLoading && this.enrollmentsLoaded) {
          this.isLoading = true
        }
      }
    }
  },
  components: {
    "grades-chart": GradesChart,
    "assistance-chart": AssistanceChart,
    "next-arrow-icon": NextArrowIcon,
    "dropdown-button": DropdownButton,
    loading: Loading
  },
  filters: {
    humanizeFloat(value) {
      if (value == null || Number.isNaN(value)) {
        return "-"
      }
      return (Math.round(value * 10) / 10).toFixed(1)
    },
    percentage(value, institution) {
      if (value == null || Number.isNaN(value)) {
        return "-"
      }

      if (institution == "uam.co") {
        return value
      } else {
        return (value * 100).toFixed(0) + "%"
      }
    },
    percentageSimple(value) {
      if (value == null || Number.isNaN(value)) {
        return "-"
      }
      return (value * 100).toFixed(0) + "%"
    },
    humanizeDate(value) {
      const m = moment(value)
      return m.fromNow()
    },
    truncate(text, stop) {
      return text.slice(0, stop) + (text.length > stop ? "..." : "")
    }
  }
}
</script>

<style scoped>
.home-grid {
  display: flex;
  flex-direction: column;
}

/* todo: importar variables aquí */
@media screen and (min-width: 769px) {
  .home-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 240px 200px 1fr;
    grid-column-gap: 8px;
    grid-row-gap: 6px;
  }
}

.profile-enrollment {
  display: flex;
  align-items: stretch;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.profile-enrollment b {
  font-weight: 500;
  display: contents;
}

.profile-enrollment__desertion-rate {
  padding: 1.25rem 0.75rem;
  background-color: var(--color-gray-00);
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--color-gray-00);
  border-radius: 0.5rem 0 0 0.5rem;
}

.profile-enrollment__desertion-rate.profile-enrollment__desertion-rate--success {
  background-color: var(--color-success-50);
}

.profile-enrollment__desertion-rate.profile-enrollment__desertion-rate--warning {
  background-color: var(--color-warning-50);
}

.profile-enrollment__desertion-rate.profile-enrollment__desertion-rate--danger {
  background-color: var(--color-error-50);
}

.profile-enrollment__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background-color: var(--color-gray-00);
  border-radius: 0 0.5rem 0.5rem 0;
  gap: 1rem;
  width: 100%;
}

.profile-enrollment__content .program {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
  margin: 0;
}

.profile-enrollment__dropdown {
  flex-shrink: 0;
}

.infographic {
  background: white;
  margin-bottom: 5px;
  overflow: auto;
  grid-column: 1 / span 2;
  border-radius: 8px;
}

.main-box {
  box-sizing: border-box;
  background: white;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
}

.main-box .title-link {
  font-family: Roboto;
  color: var(--color-primary-60);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  font-size: 22px;
  line-height: 26px;
  padding: 15px;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px solid #bdbdbd;
}

.main-box .title-link:hover {
  text-decoration: underline;
}

.main-box .title-link:active {
  color: white;
  background-color: var(--color-primary-60);
}

.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 !important;
}

.main-box .body {
  flex-grow: 1;
  min-height: 120px;
  padding: 20px 30px;
  max-height: 200px;
  overflow: auto;
}

.main-box .body h4 {
  font-weight: bold;
  color: var(--color-neutral-90);
  font-size: 14px;
  line-height: 14px;
  font-family: Roboto;
}

.risk-factors {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 10px;
  padding-left: 10px;
}

.risk-factors-item {
  flex-basis: 50%;
  margin: 3px 0;
}

.risk-factor-name {
  font-size: 14px;
  line-height: 18px;
  font-family: Roboto;
  color: var(--color-neutral-90);
}

.risk-factor-indicator {
  display: inline-block;
  margin-right: 5px;
  width: 10px;
  height: 10px;
  background: #e0e0e0;
  border-radius: 25%;
}

.risk-factor-indicator.is-at-risk {
  background: var(--color-error-50);
}

/* METRICS */

.metric-list {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
}

.metric-list-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.metric-list-item .metric-value {
  font-family: Roboto;
  font-size: 40px;
  line-height: 32px;
  font-weight: medium;
  margin-bottom: 5px;
  color: var(--color-neutral-70);
}
.metric-list-item .metric-concept {
  font-size: 14px;
  line-height: 18px;
  font-family: Roboto;
  color: var(--color-neutral-90);
}

/* COMMENTS */
.comments-list {
  font-size: 14px;
}

.comments-list .comment-meta,
.comments-list .comment-text {
  font-family: Roboto;
  font-size: 14px;
  line-height: 18px;
  color: var(--color-neutral-90);
}

.comment-item {
  margin: 10px 0;
}

.comment-text {
  display: inline;
  margin: 0;
}

.see-more {
  color: #333;
}

.infographic-tabs {
  list-style: none;
  margin: 0;
  padding: 0;
  padding: 15px 0px 5px;
  margin: 0 50px 25px 56px;
  border-bottom: 1px solid var(--color-neutral-30);
}

.infographic-tabs li {
  display: inline;
  padding: 5px 10px;
  margin: 0 0px;
  font-size: 14px;
  line-height: 14px;
  color: var(--color-neutral-70);
  font-family: Roboto;
}

.infographic-tabs li a {
  color: inherit;
  text-decoration: none;
}

.infographic-tabs li.active {
  border-bottom: 1px solid var(--color-neutral-70);
}
.infographic-tabs li.active a {
  font-weight: bold;
  color: var(--color-neutral-90) !important;
}
</style>
